import * as React from 'react';
import MapButton from './MapButton';
import IconButton from '@material-ui/core/IconButton';
import { default as IconZoomIn } from '@material-ui/icons/Add';
import { default as IconZoomOut } from '@material-ui/icons/Remove';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
const useStyles = makeStyles(() => createStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
    },
    buttonFirst: {
        marginBottom: 8,
    },
}));
const ZoomButtons = (props) => {
    const { className, map } = props;
    const zoomIn = () => {
        map === null || map === void 0 ? void 0 : map.zoomIn();
    };
    const zoomOut = () => {
        map === null || map === void 0 ? void 0 : map.zoomOut();
    };
    const classes = useStyles();
    return (React.createElement("div", { className: clsx(classes.root, className) },
        React.createElement(MapButton, { className: classes.buttonFirst },
            React.createElement(IconButton, { color: 'inherit', onClick: zoomIn },
                React.createElement(IconZoomIn, null))),
        React.createElement(MapButton, null,
            React.createElement(IconButton, { color: 'inherit', onClick: zoomOut },
                React.createElement(IconZoomOut, null)))));
};
export default ZoomButtons;
